//check if page contains grid-view-item


if (document.querySelector('.customize-grid-view-item-color-selector-container') != null){
    let last_images = []

    function changeGVIImage(e,ele){
        let grid_view_item = ele.parentElement.parentElement.parentElement.parentElement
        
        Array.from(grid_view_item.querySelectorAll('img')).forEach(img=>img.style.display='none')
        
        let color = ele.dataset.gvicolor
        let prod_id = ele.dataset.gviprodid
        document.getElementById('Customize-GVI-Color-'+ color + '-' + prod_id).style.display = 'block'
        
        if (last_images.length > 20){
            last_images = []
        } 

        last_images.unshift({prod_id:prod_id,element:'Customize-GVI-Color-'+ color + '-' + prod_id})

    }

    function changeGVIImageOut(e,ele){
        let grid_view_item = ele.parentElement.parentElement.parentElement.parentElement
        
        Array.from(grid_view_item.querySelectorAll('img')).forEach(img=>img.style.display='')
 
    }
    
    function holdLastGVIImage(e,ele){
        let prod_id = ele.dataset.gviprodid
        let img = last_images.filter(img=>img.prod_id === prod_id)[0]
        let grid_view_item = ele.parentElement.parentElement.parentElement.parentElement
        
        if(img){
            Array.from(grid_view_item.querySelectorAll('img')).forEach(img=>img.style.display='none')

            document.getElementById(img['element']).style.display = 'block'
    
        }
     
    }

    function holdLastGVIImageOut(e,ele){
        let grid_view_item = ele.parentElement.parentElement.parentElement.parentElement
        
        Array.from(grid_view_item.querySelectorAll('img')).forEach(img=>img.style.display='')
     
    }



    function clickChangeGVIImage(e,ele){
        let grid_view_item = ele.parentElement.parentElement.parentElement.parentElement
        
        Array.from(grid_view_item.querySelectorAll('img')).forEach(img=>img.style.display='none')
        
        let color = ele.dataset.gvicolor
        let prod_id = ele.dataset.gviprodid
        document.getElementById('Customize-GVI-Color-'+ color + '-' + prod_id).style.display = 'block'
        
        if (last_images.length > 20){
            last_images = []
        } 

        last_images.unshift({prod_id:prod_id,element:'Customize-GVI-Color-'+ color + '-' + prod_id})
       
        e.preventDefault()
    }
}